import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/AnnouncementsResource.ts
var n = class n extends t {
	static {
		this.publicBaseUrl = `/api/private/organizations/${e.orgPlaceholder}/announcements`;
	}
	static {
		this.managementBaseUrl = "/api/private/global/management/announcements";
	}
	list() {
		return this.api.get(this.buildPath(n.publicBaseUrl));
	}
	listGlobal(e) {
		return this.api.get(this.buildPath(n.managementBaseUrl, e));
	}
	get(e) {
		return this.api.get(`${n.managementBaseUrl}/${e}`);
	}
	create(e) {
		return this.api.post(n.managementBaseUrl, e);
	}
	update(e, t) {
		return this.api.put(`${n.managementBaseUrl}/${e}`, t);
	}
	delete(e) {
		return this.api.delete(`${n.managementBaseUrl}/${e}`);
	}
};
//#endregion
export { n as AnnouncementsResource };

//# sourceMappingURL=AnnouncementsResource.js.map